<template>
    <div>
        <iframe
            v-if="areGamesLoaded"
            :src="virtualGameSrc"
            class="w-full"
            style="height: calc(100vh - 120px);"
        />
        <div
            v-else
            class="spinner-container"
        >
            <SpinnerBars/>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { links } from '@app/router/constants';

    export default {
        name: 'VirtualResultsContainer',
        data() {
            return {
                selectedVirtualGame: null,
            };
        },
        created() {
            if (this.areGamesLoaded) {
                this.setGameType();
            }
            this.$watch(
                () => ([this.$route.params.gameType, this.areGamesLoaded]),
                (gameType, areGamesLoaded) => {
                    if (areGamesLoaded) {
                        this.setGameType();
                    }
                }
            );
        },
        computed: {
            ...mapGetters('ui/results/virtuals', [
                'IFrameUrl',
            ]),
            ...mapGetters('data/games', [
                'virtualGames',
                'virtualShopsGames',
                'areGamesLoaded',
            ]),
            virtualGameSrc() {
                if (!this.selectedVirtualGame) {
                    return null;
                }
                return this.IFrameUrl(this.selectedVirtualGame);
            }
        },
        methods: {
            setGameType() {
                const gameTypeParam = this.$route.params.gameType;
                const gameType = this.virtualGames.find((g) => g.name === gameTypeParam)
                    || this.virtualShopsGames.find((g) => g.name === gameTypeParam);
                if (!gameType) {
                    this.$router.push(links.page_404);
                }
                this.selectedVirtualGame = gameType;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/results/virtual/VirtualResultsContainer.vue